import { create } from 'zustand';
import { StoreSetting } from '../types/StoreSetting';
import { useStoreListStore } from './storeListStore';

interface StoreSettingStore {
  storeSetting: StoreSetting | null;
  setStoreSetting: (storeSetting: StoreSetting) => void;
  updateDefaultStore: (storeId: number) => void;
}

export const useStoreSettingStore = create<StoreSettingStore>((set, get) => ({
  storeSetting: null,
  setStoreSetting: (storeSetting: StoreSetting) => set({ storeSetting }),
  updateDefaultStore: (storeId: number) => {
    const { stores } = useStoreListStore.getState();
    const storefront = stores.find((e) => e.id === storeId) ?? stores[0];
    const currentSetting = get().storeSetting;
    if (currentSetting) {
      const updatedSetting = StoreSetting.fromJson({
        ...currentSetting.toJson(),
        defaultStore: storefront.id,
      });

      get().setStoreSetting(updatedSetting);
    }
  },
}));
